module.exports = new __parcel__URL__("home_spectate.75664ffb.webp").toString();